import type { Backfill } from '@customerio/hydra-ui-api';
import type { BackfillComputed } from '../types';
import { getTaskTypeInfo, type BackfillType } from './task-types';

export function transformBackfill(backfill: Backfill): BackfillComputed {
  const info = getTaskTypeInfo(backfill.type as BackfillType);
  const isPending = !['Success', 'Failure', 'Canceled'].includes(backfill.state);

  return {
    ...backfill,
    isPending,
    info,
  };
}
